import type { REMOTE_CONFIG_TYPED_DEFAULTS } from '../constants/remoteConfig.constant';

/**
 * Serializa los valores por defecto para Firebase Remote Config
 * 
 * @param {typeof REMOTE_CONFIG_TYPED_DEFAULTS} defaults - Valores por defecto tipados
 * @returns {Record<string, string | number | boolean>} Valores serializados para Firebase
 */
export function serializeForFirebase(
  defaults: typeof REMOTE_CONFIG_TYPED_DEFAULTS
): Record<string, string | number | boolean> {
  const result: Record<string, string | number | boolean> = {};
  
  for (const [key, value] of Object.entries(defaults)) {
    result[key] = typeof value === 'object' ? JSON.stringify(value) : value;
  }
  
  return result;
}
